module.exports = __webpack_public_path__ + "img/9.0be86410.jpg";